import React from 'react'
import { useTranslation } from 'react-i18next'
import { FiGrid } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import {
  Label,
  Link,
  MenuElement,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import Badge from '../../../../../components/Template/Badge'
import { useSelector } from 'react-redux'
import { IStore } from '../../../../../reducers'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { getUserId } from '../../../../../reducers/userAccount/selectors/userAccount'

function OldWidgets({ size = 1 }: IWithSize) {
  const { t } = useTranslation()
  const isSidebarOpen = useSelector(
    (state: IStore) => state.bookingCalendar.isSidebarOpen,
  )
  const userId = useSelector(getUserId)

  const trackClick = () => {
    Mixpanel.people.increment(userId, 'Widget Menu Opened', 1)
    Mixpanel.track('Main Menu Widget Item Used', {})
  }

  return (
    <MenuElement size={size} alignCenter={true}>
      <Link onClick={trackClick} size={size} to={'/widgets-old'}>
        <Flex alignCenter={true}>
          <b>
            <FiGrid size={16 * size} />
          </b>
          <Label size={size} primary={true}>
            {t('menu_widgets')}
          </Label>
          {isSidebarOpen && (
            <div>
              <Badge size={size} error={true}>
                OLD
              </Badge>
            </div>
          )}
        </Flex>
      </Link>
    </MenuElement>
  )
}

export default OldWidgets
